var jade = require("E:\\codecombat-win-edu-v6\\codecombat\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (message, status, statusText) {
buf.push("<div id=\"modal-error\" class=\"modal fade\"><div class=\"modal-dialog\"><div class=\"modal-header\"><div type=\"button\" data-dismiss=\"modal\" aria-hidden=\"true\" class=\"button close\">&times;</div><h3>Error " + (jade.escape((jade_interp = status) == null ? '' : jade_interp)) + ": " + (jade.escape((jade_interp = statusText) == null ? '' : jade_interp)) + "</h3></div><div class=\"modal-body\"><p>" + (jade.escape((jade_interp = message) == null ? '' : jade_interp)) + "</p></div></div></div>");}.call(this,"message" in locals_for_with?locals_for_with.message:typeof message!=="undefined"?message:undefined,"status" in locals_for_with?locals_for_with.status:typeof status!=="undefined"?status:undefined,"statusText" in locals_for_with?locals_for_with.statusText:typeof statusText!=="undefined"?statusText:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/error.jade
// module id = 514
// module chunks = 100